$(document).on('ready turbolinks:load', () => {
  const $modal = $('#modal[data-back-url]');
  if ($modal.find('.modal-body').length > 0) {
    $modal.modal('show');
    $modal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
      if ($modal.data('back-url')) { Turbolinks.visit($modal.data('back-url')); }
    });
  }
  // Trigger load when modal loads remotely
  $('a[data-remote][data-trigger=modal]').off('ajax:success').on('ajax:success', () => {
    $(document).trigger('turbolinks:load');
  });
});
